<template>
  <div class="faq-tab">
    <ul
      v-if="items.length"
      class="content"
    >
      <li
        v-for="(item,index) in items"
        :key="item.id"
        @click="toggle(index)"
        :class="{active: index==activeIndex}"
      >
        <div class="ttl-box">
          <span
            class="faq-title"
            v-html="item.title"
          ></span>
          <i class="icon-arrow"></i>
        </div>
        <p
          class="faq-content"
          v-html="item.content"
        ></p>
      </li>
    </ul>
    <error-panel
      v-else
      :type="'noData'"
    ></error-panel>
  </div>
</template>
<script>
import config from '../config/'
import { getFaqs } from '../services/'

export default {
  name: 'index',
  data () {
    return {
      type: '',
      items: [],
      activeIndex: '9999'
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.$spinner.open('正在查询...')
      getFaqs({
        faqCode: config.faqCode
      }).then(res => {
        let { data } = res
        if (data && data.length > 0) {
          this.$spinner.close()
          this.items = data
        } else {
          this.$spinner.close()
        }
      }).catch(() => {
        this.$spinner.close()
        this.$router.push({name: 'servererror'})
      })
    },
    toggle (val) {
      if (this.activeIndex === val) {
        this.activeIndex = '9999'
      } else {
        this.activeIndex = val
      }
    }
  }

}
</script>
<style scoped lang="scss">
  @import "../assets/common.scss";
  .faq-tab {
    @extend %container;
    .content{
      @extend %content;
    }
    li {
      border-bottom: solid 1PX #dddddd; /*no*/
      margin: 0 29px;
      &:last-child{
        border: none;
      }
      .ttl-box{
        padding: 53px 0 45px 0;
        @extend %flex-row;
        justify-content: space-between;
        .faq-title {
          font-size: 42px;
          color: #000;
        }
        .icon-arrow {
          width: 24px;
          height: 45px;
          background-image: url("../assets/image/icon-j.png");
          background-repeat: no-repeat;
          background-size: contain;
          transition: All 0.2s ease-in-out;
          flex: 0 0 auto;
        }
      }
      .faq-content {
        display: none;
        font-size: 36px;
        color: #666666;
      }
      &.active {
        .icon-arrow {
          background-image: url("../assets/image/icon-j2.png");
          transform: rotate(90deg);
          -webkit-transform: rotate(90deg);
          -moz-transform: rotate(90deg);
          -o-transform: rotate(90deg);
          -ms-transform: rotate(90deg);
        }
        .faq-content {
          padding-bottom: 72px;
          display: block;
        }
      }
    }
  }
</style>
